import React, { useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import axios from 'axios';
import { BASE_URL } from '../api/api';
import { Auth } from '../context/Auth';
import { useCookies } from 'react-cookie';

import Logo from '../assets/logos/codemmit-logo.png'
import Explore from "../assets/icons/explore.svg"
import Clock from "../assets/icons/clock.svg"

import '../styles/Sidebar.scss'

const Sidebar = () => {
    const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn', 'channelId']);
    const navigate = useNavigate();
    const auth = useContext(Auth);

    const followedChannel = [
        {
            logo: Logo,
            name: 'Codemmit',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'Codevolution',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'Coding With Hitesh',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'Coding With thapa',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'Coding Ninja',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'CodeX',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'Colors',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'W3Schools',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'Codevolution',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'Codevolution',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
        {
            logo: Logo,
            name: 'Coding With Hitesh',
            channelId: '87636e42-ca02-4da0-a4e1-3fa9205235b2',
            channelHandle: 'codemmit07',
            link: '/'
        },
    ];

    const viewChannelHome = (visitedChannelHandle, visitedChannelId) => {
        // window.sessionStorage.setItem("visitedChannelId", JSON.stringify(visitedChannelId));
        navigate(`/profile/${visitedChannelHandle}?id=${visitedChannelId}`);
    }

    const visitUserChannel = () => {
        auth.authReducerDispatch({ type: "updateVisitedChannelId", payload: auth.authState.channelId })

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `${cookies.token}`
        };

        axios.post(`${BASE_URL}/api/channels/fetch-channel`, {
            channelId: auth.authState.channelId,
            requestingUserId: auth.authState.channelId
        }, { headers: headers })
            .then(res => {
                const data = res.data.channelData;
                console.log(res, "Channel Fetched in Header.js")
                navigate(`/my-channel/${data.channelHandle}?id=${auth.authState.channelId}`);
            })
            .catch(err => console.log(err, "Error!, Fecthing channel details"))
    }

    return (
        <div className='sidebar'>
            <div className="sidebar__container">
                <div className="sidebar__channel-menu">
                    <ul>
                        <li>
                            <Link to="/explore" className='sidebar__channel-link  sidebar__channel-link--explore'>
                                <img src={Explore} alt="explore" />
                                <p>Explore</p>
                            </Link>
                        </li>
                        <li>
                            <Link to="/recent" className='sidebar__channel-link  sidebar__channel-link--explore'>
                                <img src={Clock} alt="clock" />
                                <p>Recent</p>
                            </Link>
                        </li>
                    </ul>
                    {
                        auth.authState.channelId && <ul>
                            <li>
                                <button className='sidebar__channel-link' onClick={visitUserChannel}>
                                    <img src={Logo} alt="channel-logo" />
                                    <p>My Channel</p>
                                </button>
                            </li>
                        </ul>
                    }
                    <h2 className='sidebar__menu-title'>Following</h2>
                    <ul className='sidebar__followed-container'>
                        {
                            followedChannel.map(channel => <li key={channel.name}>
                                <button className='sidebar__channel-link' onClick={() => { viewChannelHome(channel.channelHandle, channel.channelId) }}>
                                    <img src={channel.logo} alt="channel-logo" />
                                    <p>{channel.name}</p>
                                </button>
                            </li>)
                        }
                    </ul>

                    {/* <h2 className='sidebar__menu-title'>Tools</h2> */}
                    {/* <Link to="/img-to-pdf" className='sidebar__action-link'>
                        <span className="material-symbols-outlined">
                            autorenew
                        </span>
                        <p>Image To PDF</p>
                    </Link> */}

                    {/* <Link to="/monitization" className='sidebar__monitization-link'>
                        <span className="material-symbols-outlined"> local_atm</span>
                        <p>Monetization</p>
                    </Link> */}
                </div>
            </div>
        </div>
    )
}

export default Sidebar